import React from 'react';

const ReviewStarIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1812 3.81081C13.4048 2.25838 11.0913 2.25838 10.3149 3.81081L8.94824 6.5436C8.63018 7.17959 7.99187 7.61447 7.25878 7.69464L4.14938 8.03467C2.31154 8.23565 1.58632 10.4174 2.96614 11.5943L5.16157 13.4669C5.73116 13.9527 5.98698 14.6914 5.83306 15.4058L5.23488 18.1824C4.86801 19.8854 6.75073 21.2219 8.35194 20.3952L11.2294 18.9097C11.865 18.5815 12.631 18.5815 13.2667 18.9097L16.1442 20.3952C17.7454 21.2219 19.6281 19.8854 19.2612 18.1824L18.663 15.4058C18.5091 14.6914 18.7649 13.9527 19.3345 13.4669L21.53 11.5943C22.9098 10.4174 22.1846 8.23565 20.3467 8.03467L17.2373 7.69464C16.5042 7.61447 15.8659 7.17959 15.5479 6.5436L14.1812 3.81081Z"
        fill="#F9AB3A"
      />
    </svg>
  );
};

export default ReviewStarIcon;
